import React, { useState, useEffect } from "react";
import Button from "../../../Other/element/Button";
import ChapterDocument from "../../../Courses/CourseDetails/CourseChapterDetails/chapterDocument";
import OverlayContainer from "../../../Overlay/OverlayContainer";
import { getS3URL } from "../../../../_helpers";
import { Link } from "react-router-dom";
import { FetchNext } from "../../../Other/FetchNext/FetchNext";
import { connect, useDispatch, useSelector } from "react-redux";
import { courseActions } from "../../../../_actions";
const ViewAward = ({ isFetching, courses }) => {
  const dispatch = useDispatch();
  const { all } = courses;

  const { user } = useSelector((state) => state.users);

  const [printCertificate, setPrintCertificate] = useState(false);
  const [cerftificateUrl, setCertificateUrl] = useState();

  const showHandler = (url) => {
    setCertificateUrl(url);
    setPrintCertificate(!printCertificate);
  };
  useEffect(() => {
    if (!all.currentPage) {
      dispatch(courseActions.viewAwardCourse(1));
    }
  }, []);
  const handleFetchNext =
    (isFetching, currentPage, totalPage) => (observer) => {
      if (!isFetching && currentPage < totalPage) {
        dispatch(courseActions.viewAwardCourse(++currentPage));
      } else {
        observer.disconnect();
      }
    };

  return (
    <>
      {all?.courses?.length === 0 && (
        <div class="no-record-award">
          <span className="recordNotFound">No Record found</span>
        </div>
      )}

      {all?.courses?.map((element, index) => (
        <div className="main studentPurchase" key={index}>
          <div className="img-container">
            <img
              src={getS3URL(element.imageFiles[0].fileName)}
              className="img"
              alt="courseImage"
            />
          </div>

          <div className="content">
            <div className="content-inner">
              <div className="inner-top">
                <div className="inner-top-flex">
                  <div className="right studentname">
                    <p>Student Name: {element.userName} </p>
                  </div>
                </div>
                <div className="inner-top-flex">
                  <p className="courseNameResponsive">
                    Course Name: {element.courseName}
                  </p>
                </div>
                <div className="inner-top-flex">
                  <p className="courseNameResponsiveAgain">
                    createdOn: {new Date(element.createdOn).toLocaleString()}
                  </p>
                </div>
              </div>
            </div>

            <div className="list-btn-div">
              <div className="view-section downloadCertificate">
                <Button
                  title="Certificate"
                  className="btn"
                  backgroundColor="#4169e1"
                  textColor="#FFFFFF"
                  // handleClick={() => showHandler(element.fileName)}
                />
              </div>
              <div className="view-section">
                <Link
                  className="btn-edit-content quickview"
                  to={{
                    pathname: `/dashboard/categories/${element.courseId}`,
                  }}
                >
                  QUICK VIEW
                </Link>
              </div>
            </div>
          </div>
        </div>
      ))}
      {all.currentPage < all.totalPage && (
        <FetchNext
          isFetching={isFetching}
          currentPage={all.currentPage}
          handleFetchNext={handleFetchNext(
            isFetching,
            all.currentPage,
            all.totalPage
          )}
        />
      )}

      {printCertificate && (
        <OverlayContainer>
          <ChapterDocument
            type={"pdf"}
            url={getS3URL(cerftificateUrl)}
            closeHandler={showHandler}
            show={printCertificate}
          />
        </OverlayContainer>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  const { viewAwardCourse, isFetching } = state.course;
  return {
    isFetching: isFetching,
    courses: viewAwardCourse || [],
  };
};

export default connect(mapStateToProps)(ViewAward);
